import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';

export interface MessageOptions {
  summary?: string;
  life?: number;
  closable?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class MessageNotificationService {
  constructor(private messageService: MessageService) {}

  /**
   * Exibe mensagem de erro
   */
  showError(detail: string, summary: string = 'Erro', options?: MessageOptions): void {
    this.messageService.add({
      severity: 'error',
      summary: summary,
      detail,
      life: options?.life ?? 5000,
      closable: options?.closable ?? true,
    });
  }

  /**
   * Exibe mensagem de sucesso
   */
  showSuccess(detail: string, summary: string = 'Sucesso', options?: MessageOptions): void {
    this.messageService.add({
      severity: 'success',
      summary: summary,
      detail,
      life: options?.life ?? 3000,
      closable: options?.closable ?? true,
    });
  }

  /**
   * Exibe mensagem de aviso
   */
  showWarning(detail: string, summary: string = 'Atenção', options?: MessageOptions): void {
    this.messageService.add({
      severity: 'warn',
      summary: summary,
      detail,
      life: options?.life ?? 4000,
      closable: options?.closable ?? true,
    });
  }

  /**
   * Exibe mensagem informativa
   */
  showInfo(detail: string, summary: string = 'Informação', options?: MessageOptions): void {
    this.messageService.add({
      severity: 'info',
      summary: summary,
      detail,
      life: options?.life ?? 3000,
      closable: options?.closable ?? true,
    });
  }

  /**
   * Limpa todas as mensagens
   */
  clear(): void {
    this.messageService.clear();
  }
}

